<template>
  <div class="member-base">
    <router-view />
    <div v-if="$route.meta.footer.show" class='common-footer-wrap'>
      <mt-tabbar v-model='home_selected' fixed class="common-footer">
        <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'HomeIndex' }" id='home_index'><router-link
            :to="{ name: 'HomeIndex' }" class='item'><img src="../../assets/image/tab/icon_home_pre.png" class="image"
              v-if="$route.name == 'HomeIndex'"><img v-else src="../../assets/image/tab/icon_home_nor.png"
              class="image" /><span class='text'>{{ $t('Home') }}</span></router-link></mt-tab-item>

        <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'HomeGoodsclass' }"
          id='home_goodsclass'><router-link :to="{ name: 'HomeGoodsclass' }" class='item'><img
              src="../../assets/image/tab/icon_classify_pre.png" class="image" v-if="$route.name == 'HomeGoodsclass'"><img
              v-else src="../../assets/image/tab/icon_classify_nor.png" class="image" /><span class='text'>
              {{ $t('Category') }}</span></router-link></mt-tab-item>


        <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'GiftSave' }" id='home_search'><router-link
            :to="{ name: 'GiftSave' }" class='item'><img src="../../assets/image/tab/Recycle_pre.png" class="image"
              v-if="$route.name == 'GiftSave'"><img v-else src="../../assets/image/tab/Recycle.png" class="image" /><span
              class='text'>{{ $t('Recycle') }}</span></router-link></mt-tab-item>

        <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'HomeCart' }" id='home_cart'><router-link
            :to="{ name: 'HomeCart' }" class='item'><img src="../../assets/image/tab/icon_shopping_pre.png" class="image"
              v-if="$route.name == 'HomeCart'"><img v-else src="../../assets/image/tab/icon_shopping_nor.png"
              class="image" /><span class='text'>{{ $t('Cart') }}</span><span class="icon" v-if="cartNumber > 0">{{
                getCarCount
              }}</span></router-link></mt-tab-item>
        <mt-tab-item class='item-wrap button' :class="{ 'active': $route.name == 'MemberIndex' }" id='member_index'><router-link
            :to="{ name: 'MemberIndex' }" class='item'><img src="../../assets/image/tab/icon_mine_pre.png" class="image"
              v-if="$route.name == 'MemberIndex'"><img v-else src="../../assets/image/tab/icon_mine_nor.png"
              class="image" /><span class='text'>{{ $t('Mine') }}</span></router-link></mt-tab-item>
      </mt-tabbar>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { cartQuantity } from '../../api/homecart'
export default {
  name: 'MemberBase',
  data() {
    return {
      home_selected: 'member_index',
      cartNumber: 0
    }
  },
  computed: {
    ...mapState({
      user: state => state.member.info,
      isOnline: state => state.member.isOnline
    }),
    getCarCount() {
      if (this.cartNumber > 0 && this.cartNumber < 100) {
        return this.cartNumber
      } else if (this.cartNumber >= 100) {
        return '99+'
      }
    }
  },
  created: function () {
    if (!this.user) {
      this.$router.push({ name: 'HomeMemberLogin', query: { clear: 1 } })
    }
    // this.getCartCount()
  },
  methods: {
    getCartCount() {
      if (this.isOnline) {
        cartQuantity().then(res => {
          if (res) {
            this.cartNumber = res.result.cart_count
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.item-wrap {
  position: relative
}

.image {
  width: 1rem;
  height: 1rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: .2rem;
  margin-bottom: .2rem;
}

.icon {
  position: absolute;
  right: 0.8rem;
  top: 0.2rem;
  font-size: $h6;
  line-height: 0.7rem;
  width: 0.9rem;
  height: 0.7rem;
  background: #ef3338;
  border-radius: 1rem;
  text-align: center;
  color: #ffffff;
}
</style>
